import script from "./StaffView.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffView.vue?vue&type=script&setup=true&lang=js"

import "./StaffView.vue?vue&type=style&index=0&id=76241346&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76241346"]])

export default __exports__